var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("客户统计分析"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Tabs",
                    { attrs: { animated: false } },
                    [
                      _c(
                        "TabPane",
                        { attrs: { label: "订购数量", name: "orderQuantity" } },
                        [
                          _c("CustomerOrderQuantity", {
                            ref: "customerOrderQuantity",
                          }),
                        ],
                        1
                      ),
                      _c(
                        "TabPane",
                        { attrs: { label: "订购次数", name: "orderCount" } },
                        [
                          _c("CustomerOrderCount", {
                            ref: "customerOrderCount",
                          }),
                        ],
                        1
                      ),
                      _c(
                        "TabPane",
                        { attrs: { label: "售价变化", name: "priceChange" } },
                        [
                          _c("CustomerOrderPriceChange", {
                            ref: "customerOrderPriceChange",
                          }),
                        ],
                        1
                      ),
                      _c(
                        "TabPane",
                        {
                          attrs: {
                            label: "品种客户数量",
                            name: "productCustomerQantity",
                          },
                        },
                        [
                          _c("CustomerProductQantity", {
                            ref: "customerProductQantity",
                          }),
                        ],
                        1
                      ),
                      _c(
                        "TabPane",
                        {
                          attrs: {
                            label: "客户品种数量",
                            name: "customerProductQantity",
                          },
                        },
                        [
                          _c("CustomerQantityProduct", {
                            ref: "customerQantityProduct",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }